export const ADD_TO_COMPARISON = 'ADD_TO_COMPARISON';
export const REMOVE_FROM_COMPARISON = 'REMOVE_FROM_COMPARISON';
export const CLEAR_COMPARISONS = 'CLEAR_COMPARISONS';

export const receiveComparison = (result) => ({
    type: ADD_TO_COMPARISON,
    result
});

export const removeComparison = (resultTitle) => ({
    type: REMOVE_FROM_COMPARISON,
    resultTitle
});

export const clearComparisons = () => ({
    type: CLEAR_COMPARISONS
});